import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './footer.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class Footer extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      hidden: { type: Boolean },
    };
  }

  constructor() {
    super()
    this.hidden = false
  }

  intersectionCallback(entries) {
    entries.forEach(entry => {
      const locationApp = document.querySelector('hf-location-app')
      if (locationApp) {
        locationApp.setControlState(entry.isIntersecting)
      }
    })
  }

  connectedCallback() {
    super.connectedCallback()
    this.setFooterStateHandler = this.setFooterState.bind(this)
    window.addEventListener('hf-footer-set-state', this.setFooterStateHandler)
    window.addEventListener('load', () => {
      this.observer = new IntersectionObserver(this.intersectionCallback)
      const target = this.shadowRoot.querySelector('.footer-wrapper')
      this.observer.observe(target)
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.setFooterStateHandler = this.setFooterState.bind(this)
    window.removeEventListener(
      'hf-footer-set-state',
      this.setFooterStateHandler
    )
  }

  setFooterState(message) {
    this.hidden = message.detail.hidden
  }

  render() {
    return html`
      <footer
        class="${classMap({
          'footer-wrapper': true,
          'footer-wrapper--hidden': this.hidden,
        })}"
      >
        <hf-container class="footer-wrapper__inner">
          <slot></slot>
        </hf-container>
      </footer>
    `;
  }
}

customElements.define('hf-footer', Footer);
